import React from 'react'
import Stepper from './Stepper'
import { Box, Typography } from '@mui/joy'
import { useSession } from '@hooks/useSession'
import { useGetTermsAndConditionsQuery } from '@endpoints/termsConditionsEndpoint'

const TermsAndConditions = () => {
  const { user } = useSession()

  const {
    data: allTerms,
    isLoading: isLoadingTerms,
    isError: isErrorTerms,
  } = useGetTermsAndConditionsQuery(undefined, { skip: !user })

  const lastTerm = allTerms ? allTerms.slice(-1)[0] : null

  const steps = [
    {
      title: 'Términos y condiciones',
      content: (
        <Box
          sx={{
            overflowY: 'auto',
            p: 2,
          }}
        >
          <Typography
            component="div"
            sx={{ color: '#676767' }}
          >
            <span dangerouslySetInnerHTML={{ __html: lastTerm?.message ?? '' }} />
          </Typography>
        </Box>
      ),
      completed: true,
    },
  ]
  return (
    <Stepper
      isLoading={isLoadingTerms}
      error={isErrorTerms}
      title={'Acuerdo del usuario'}
      style="joy"
      steps={steps}
    />
  )
}

export default TermsAndConditions
